import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';

const Anonymous: React.SFC = () => {
  return (
    <ul className="ibm-cloud-sitenav-menu-list ibm-cloud-sitenav-user" role="menubar" data-testid="anonymous">
      <li className="ibm-cloud-sitenav-level-0">
        <a className="ibm-btn-sec" role="menuitem" href="https://cloud.ibm.com/login" data-altlabel="Log in">
          <FormattedMessage {...messages.logIn} />
        </a>
      </li>
      <li className="ibm-btn-pri ibm-cloud-sitenav-level-0">
        <a className="ibm-btn-pri ibm-cloud-sitenav-user__cta-link" role="menuitem" href="https://cloud.ibm.com/registration" data-altlabel="Start free">
          <FormattedMessage {...messages.startFree} />
        </a>
      </li>
    </ul>
  );
};

export default Anonymous;
